import React, { useEffect } from "react";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import AnexoVisualizar from "../../../../components/anexo/AnexoVisualizar";
import DegravacaoController from "../controller/degravacao.controller";

interface Props {
  controller: EventoVisualizarController;
}

export default function Degravacao({ controller }: Props) {
  const evento = controller.evento;
  const _controller = new DegravacaoController();
  const lista = _controller.lista;

  useEffect(() => {
    if (controller.tab === "degravacao") {
      _controller.obterDegravacao(evento.codAudienciaPublica);
    }
  }, [controller.tab]);
  return (
    <>
      <If condition={controller.tab === "degravacao"}>
        <div className="py-4 px-4">
          <h3>Degravação</h3>
        </div>
        <div className="evento-vis-card-tab">
          <div className="evento-norma-definitiva">
            <If condition={!!lista && lista.length > 0}>
              {lista.map((m: any, index: any) => (
                <AnexoVisualizar
                  key={`degravacao-${index}`}
                  showDownload={true}
                  handleDownload={(e: any) => {
                    controller.downloadDegravacao(m.codDegravacao);
                  }}
                  anexo={{ noAnexo: m.noAnexo }}
                />
              ))}
            </If>
            <If condition={!lista || lista.length === 0}>
              <h4 className="text-center">Nenhum dado encontrado</h4>
            </If>
          </div>
        </div>
      </If>
    </>
  );
}
// 31072024